import templateUrl from './list-employees-container.component.html';
import { SiteModuleEnum } from '../../core/enum/site-module';
import { IQService, IComponentOptions } from 'angular';
import { IcdOfficeService } from '../../core/services/data-services/icd-office.service';
import { SessionService } from '../../core/services/session.service';
import { UtilityService } from '../../core/services/utility.service';

export const ListEmployeesContainerComponent: IComponentOptions = {
    controller: ListEmployeesContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        icdOfficeID: "<",
        roleAccess: "<",
        identity: "<"
    }
};

export enum RosterTabs {
    All = 2,
    Terminated = 1,
    Active = 0
}

function ListEmployeesContainerController($q: IQService, sessionService: SessionService,
    employeeService: any, icdOfficeService: IcdOfficeService, utilityService: UtilityService,
    apexApiUrl: string) {
    'ngInject';
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;
    const ROSTER_MODULE = SiteModuleEnum.Roster;

    let defaultFilter;
    vm.icdOfficeID;
    vm.employees;
    vm.employeesActive;
    vm.employeesTerm;
    vm.filters;
    vm.roleAccess;
    vm.isImpersonated;
    vm.isSiteAdmin;
    vm.onChangeFilters = onChangeFilters;
    vm.onChangePage = onChangePage;
    vm.onChangeOffice = onChangeOffice;
    vm.onExport = onExport;
    vm.onProxy = onProxy;
    vm.onSetSort = onSetSort;
    vm.columnClass = columnClass;
    vm.isSortingByField = isSortingByField;
    vm.sortDirection = 1; // Ascending.
    vm.sortField = "FirstName";
    vm.$onInit = onInit;
    vm.activeTab = 0;
    vm.onChangeTab = onChangeTab;
    vm.loadEmployees = loadEmployees;
    vm.rosterData;
    //a property binding to identify access rights in child component
    vm.canEdit;
    vm.canProxy;

    function onInit() {
        vm.isSiteAdmin = vm.identity.IsSiteAdmin;
        if (vm.icdOfficeID) {
            if (vm.filters === undefined || vm.filters === null) {
                vm.filters = {};
            }
            vm.filters.icdOfficeID = vm.icdOfficeID;
        }
        if (vm.isSiteAdmin) {
            defaultFilter = { Role: "Owner" };
        } else {
            defaultFilter = {};
        }
        defaultFilter.PageNumber = 1;
        defaultFilter.PageNumberTerm = 1;
        defaultFilter.PageNumberActive = 1;
        defaultFilter.PageSize = 15;
        defaultFilter.PageSizeTerm = 15;
        defaultFilter.PageSizeActive = 15;

        const filtersRestored = restoreFilters();

        const loaded = $q.all([
            loadIcdOffices().then(function (icdOffices) {
                vm.IcdOfficeOptions = icdOffices;
                //loading active employees on initial load
                return $q.all([filtersRestored, loadEmployees(RosterTabs.All),
                    loadEmployees(RosterTabs.Active), loadEmployees(RosterTabs.Terminated)
                ]);
            }),
            sessionService.isImpersonated()
                .then(isImpersonated => {
                    vm.isImpersonated = isImpersonated;
                    vm.canProxy = vm.isSiteAdmin && !isImpersonated;
                })
        ]);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loaded, "Initial load failed"));

    }

    function onChangeTab(tab) {
        vm.activeTab = tab;
        loadEmployees(getActiveTab());
    }

    function onChangePage() {
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loadEmployees(getActiveTab()), "Changing page failed"));
        saveFilters();
    }

    function getActiveTab() {
        return vm.activeTab === 0 ? RosterTabs.Active : vm.activeTab === 1 ? RosterTabs.Terminated : RosterTabs.All;
    }

    const changeFilters = utilityService.debounce(function (isOfficeChanged) {
        // Always reset to page one after filtering something, since we don't know what the new size will be.
        vm.filters.PageNumber = 1;
        vm.filters.PageNumberActive = 1;
        vm.filters.PageNumberTerm = 1;
        saveFilters();
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([loadEmployees(RosterTabs.All),
                loadEmployees(RosterTabs.Active),
                loadEmployees(RosterTabs.Terminated)]), "Filtering failed"));
    }, 500);

    function onChangeFilters() {
        changeFilters(false);
    }

    function onChangeOffice() {
        changeFilters(true);
    }

    function onExport() {
        const urlStrPayroll = kendo.format(apexApiUrl + 'employees.xlsx?showTerminated={0}',
            vm.filters.ShowTerminated);
        window.location.href = urlStrPayroll;
    }

    function onProxy(employeeID) {
        const proxied = sessionService.proxy(employeeID)
            .then(function () {
                window.location.href = "Home/Index";
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(proxied, "Proxying failed"));
    }

    function onSetSort(field) {
        if (vm.isSortingByField(field)) {
            vm.sortDirection = vm.sortDirection * -1;
        } else {
            vm.sortDirection = 1;
        }
        vm.filters.SortFields = [(vm.sortDirection === -1 ? "-" : "") + field];
        vm.sortField = field;
        saveFilters();

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError($q.all([loadEmployees(RosterTabs.All), loadEmployees(RosterTabs.Active), loadEmployees(RosterTabs.Terminated)]), "Sorting failed"));
    }

    function columnClass(field) {
        return vm.sortDirection === -1 ? "fas fa-sort-amount-down" : "fas fa-sort-amount-down-alt";
    }

    function isSortingByField(field) {
        return vm.sortField === field;
    }

    function restoreFilters() {
        let tempIcdOfficeFilter = undefined;
        // Restore filters to the grid from localStorage, if available.
        vm.filters = JSON.parse(localStorage.getItem("listUsersFilters")) || defaultFilter;

        if (vm.filters && vm.filters.icdOfficeID) {
            tempIcdOfficeFilter = vm.filters.icdOfficeID;
        }
        if (tempIcdOfficeFilter) {
            vm.filters.icdOfficeID = tempIcdOfficeFilter;
        }

        // Set default page index and size if they don't exist already.
        vm.filters.PageNumber = vm.filters.PageNumber || 1;
        vm.filters.PageNumberTerm = vm.filters.PageNumberTerm || 1;
        vm.filters.PageNumberActive = vm.filters.PageNumberActive || 1;
        vm.filters.PageSize = vm.filters.PageSize || 15;
        vm.filters.PageSizeTerm = vm.filters.PageSizeTerm || 15;
        vm.filters.PageSizeActive = vm.filters.PageSizeActive || 15;

        if (vm.filters.SortFields && vm.filters.SortFields.length > 0) {
            // Check the first character of the first sort.
            vm.sortDirection = vm.filters.SortFields[0][0] === "-" ? -1 : 1;
            vm.sortField = vm.filters.SortFields[0].replace("-", "");
        }
        return $q.when();
    }

    /**
     * Persist the page filters in local storage.
     */
    function saveFilters() {
        localStorage.setItem("listUsersFilters", JSON.stringify(vm.filters || {}));
    }
    function loadEmployeePage(query, pageNumber) {
        return employeeService.retrieveEmployeesPage(pageNumber - 1, query)
    }
    //active = true for active; false for terminated
    function loadEmployees(active) {
        // Prevent reloading data if an office is not selected and the user isn't a site admin.
        let query;
        if (!vm.filters.icdOfficeID && !vm.isSiteAdmin) {
            return Promise.reject("Office not selected and User require admin access");
        }
        if (active === RosterTabs.All) {
            query = {
                FirstName: vm.filters.FirstName,
                LastName: vm.filters.LastName,
                UserName: vm.filters.UserName,
                Role: vm.filters.Role,
                Office: vm.filters.Office,
                EmployeeStatus: vm.filters.EmployeeStatus,
                PageSize: vm.filters.PageSize,
                ModuleID: "Roster",
                ShowTerminated: true,
                ShowOnlyActive: false,
                SortFields: vm.filters.SortFields,
                IcdOfficeID: vm.filters.icdOfficeID
            }
            return loadEmployeePage(query, vm.filters.PageNumber).then(function (page) {
                vm.employeesPage = page;
                vm.employees = vm.employeesPage.Entities;
            });
        } else if (active === RosterTabs.Active) {
            query = {
                FirstName: vm.filters.FirstName,
                LastName: vm.filters.LastName,
                UserName: vm.filters.UserName,
                Role: vm.filters.Role,
                Office: vm.filters.Office,
                EmployeeStatus: vm.filters.EmployeeStatus,
                PageSize: vm.filters.PageSizeActive,
                ModuleID: "Roster",
                ShowTerminated: false,
                ShowOnlyActive: true,
                SortFields: vm.filters.SortFields,
                IcdOfficeID: vm.filters.icdOfficeID
            }
            return loadEmployeePage(query, vm.filters.PageNumberActive).then(function (page) {
                vm.employeesActivePage = page;
                vm.employeesActive = vm.employeesActivePage.Entities;
            });
        } else {
            query = {
                FirstName: vm.filters.FirstName,
                LastName: vm.filters.LastName,
                UserName: vm.filters.UserName,
                Role: vm.filters.Role,
                Office: vm.filters.Office,
                EmployeeStatus: vm.filters.EmployeeStatus,
                PageSize: vm.filters.PageSizeTerm,
                ModuleID: "Roster",
                ShowOnlyTerminated: true,
                SortFields: vm.filters.SortFields,
                IcdOfficeID: vm.filters.icdOfficeID
            }
            return loadEmployeePage(query, vm.filters.PageNumberTerm).then(function (page) {
                vm.employeesTermPage = page;
                vm.employeesTerm = vm.employeesTermPage.Entities;
            });
        }


    }

    function loadIcdOffices() {
        return icdOfficeService.retrieveIcdOffices({ moduleID: ROSTER_MODULE }) // Filter by roster module admin.
            .then(function (icdOffices) {
                icdOffices.forEach(function (office) {
                    office.OfficeName = kendo.format("{0} - {1} ({2})", office.OwnerName, office.IcdCorporationName, office.OfficeName);
                });
                return icdOffices.filter(function (office) {
                    // Handle module admin view where the user might be a module admin, but is not allowed to read the roster.
                    return office.CanRead;
                });
            })
            .then(function (icdOffices) {

                icdOffices.sort(function (a, b) {
                    // Show offices where the user has create and read access first.
                    if (a.CanUpdate && !b.CanUpdate) {
                        return -1;
                    } else if (!a.CanUpdate && b.CanUpdate) {
                        return 1;
                    }
                    if (a.CanCreate && !b.CanCreate) {
                        return -1;
                    } else if (!a.CanCreate && b.CanCreate) {
                        return 1;
                    }

                    const nameA = a.OfficeName.toLowerCase();
                    const nameB = b.OfficeName.toLowerCase();
                    if (nameA < nameB) {//sort string ascending
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0; //default return value (no sorting)
                });

                // Disable features if the user can't perform them for all offices.
                const missingCrud = icdOffices.reduce(function (any, office) {
                    return any || !office.CanUpdate || !office.CanCreate || !office.CanDelete;
                }, false);

                // To simplify logic, disable the "all offices" filter and pre-select the most permissive office by default.
                if ((missingCrud || icdOffices.length === 1) && icdOffices[0]) {
                    if (!vm.filters.icdOfficeID || !isValidIcdFilter(vm.filters, icdOffices)) {
                        // Set the filter by default if there is no current selection or the current selection is invalid.
                        vm.filters.icdOfficeID = icdOffices[0].Id;
                    }
                    vm.enableCreate = icdOffices[0].CanCreate;
                    vm.enableUpdate = icdOffices[0].CanUpdate;
                    vm.enableDelete = icdOffices[0].CanDelete;
                } else {
                    if (vm.filters && !isValidIcdFilter(vm.filters, icdOffices)) {
                        // Clear the filtered office ID if the office doesn't appear in the list. Treat it as unselected.
                        vm.filters.icdOfficeID = null;
                    }
                    vm.enableCreate = true;
                    vm.enableUpdate = true;
                    vm.enableDelete = true;
                }
                vm.canEdit = vm.roleAccess.CanUpdate && vm.enableUpdate;
                return icdOffices;
            });
    }

    function isValidIcdFilter(filters, icdOffices) {
        return !filters.icdOfficeID || icdOffices.some(p => p.Id === filters.icdOfficeID);
    }
}
